import { safeFormattedIntlString } from '@savgroup-front-common/core/formatters';
import { MARKETING_OFFER_TYPE } from '@savgroup-front-common/types';

import messages from '../TodoActions/BlockAction/ModalContainer/RefundConfirmationModal/messages';

interface GetMarketingOfferTypeMessageArgs {
  marketingOfferType?: MARKETING_OFFER_TYPE;
}

const getMarketingOfferTypeMessage = ({
  marketingOfferType,
}: GetMarketingOfferTypeMessageArgs): string => {
  switch (marketingOfferType?.toUpperCase()) {
    case MARKETING_OFFER_TYPE.CREDIT_NOTE.toUpperCase():
      return safeFormattedIntlString(messages.creditNote);
    case MARKETING_OFFER_TYPE.EXCHANGE_ON_SELLER_STOCK.toUpperCase():
      return safeFormattedIntlString(messages.exchangeOnSellerStock);
    case MARKETING_OFFER_TYPE.GIFT_CARD.toUpperCase():
      return safeFormattedIntlString(messages.giftCard);
    case MARKETING_OFFER_TYPE.REFUND_BY_WIRE_TRANSFER.toUpperCase():
      return safeFormattedIntlString(messages.refundByWireTransfer);
    case MARKETING_OFFER_TYPE.REFUND_ON_PAYMENT_METHOD.toUpperCase():
      return safeFormattedIntlString(messages.refundOnPaymentMethod);
    case MARKETING_OFFER_TYPE.VOUCHER.toUpperCase():
      return safeFormattedIntlString(messages.voucher);
    case MARKETING_OFFER_TYPE.CASH_REGISTER.toUpperCase():
      return safeFormattedIntlString(messages.cashRegister);
    case MARKETING_OFFER_TYPE.CHECK.toUpperCase():
      return safeFormattedIntlString(messages.check);
    case MARKETING_OFFER_TYPE.DIGITAL_GIFT_CARD.toUpperCase():
      return safeFormattedIntlString(messages.digitalGiftCard);
    case MARKETING_OFFER_TYPE.LENDER.toUpperCase():
      return safeFormattedIntlString(messages.lender);
    case MARKETING_OFFER_TYPE.LOYALTY_CARD.toUpperCase():
      return safeFormattedIntlString(messages.loyaltyCard);
    case MARKETING_OFFER_TYPE.PAYEMENT_SERVICE.toUpperCase():
      return safeFormattedIntlString(messages.paymentService);
    case MARKETING_OFFER_TYPE.INTEGRATED_PROVIDER.toUpperCase():
      return safeFormattedIntlString(messages.integratedProvider);
    case MARKETING_OFFER_TYPE.NOT_SET.toUpperCase():
      return safeFormattedIntlString(messages.notSet);
    case MARKETING_OFFER_TYPE.OTHER.toUpperCase():
      return safeFormattedIntlString(messages.other);
    case MARKETING_OFFER_TYPE.WIRE_TRANSFER.toUpperCase():
      return safeFormattedIntlString(messages.wireTransfer);
    default:
      return marketingOfferType || '';
  }
};

export default getMarketingOfferTypeMessage;
